module.exports = __webpack_public_path__ + "img/Sangeun_Cha.6fe2d062.png";